import { createSlice } from "@reduxjs/toolkit";

import {
  addClosure,
  deleteClosure,
  getAllClosures,
  getClosureDetails,
  updateClosure,
  updateClosureStatus,
} from "store/actions/closureSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  closures: [],
  expiredClosures: [],
  closureDetails: {},
};

const closureSlice = createSlice({
  name: "closures",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllClosures.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllClosures.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};

          const now = new Date();

          const validClosures = [];
          const expiredClosures = [];

          data?.forEach((item) => {
            if (
              item?.type === 1 &&
              item?.dateAndTimes?.endDate &&
              new Date(item.dateAndTimes.endDate) < now
            ) {
              expiredClosures.push(item);
            } else {
              validClosures.push(item);
            }
          });
          state.closures = validClosures;
          state.expiredClosures = expiredClosures;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllClosures.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getClosureDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClosureDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.closureDetails = data;
        }
      })
      .addCase(getClosureDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(addClosure.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addClosure.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addClosure.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateClosure.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateClosure.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateClosure.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteClosure.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteClosure.fulfilled, (state, action) => {
        const { success } = action.payload;
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.closures = state.closures.filter((item) => item._id !== id);
          // if (state.totalCount !== null) {
          //   state.totalCount -= 1
          // }
        }
      })
      .addCase(deleteClosure.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateClosureStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateClosureStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.closures = state?.closures?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateClosureStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default closureSlice.reducer;
